import Slides from './slides'

export default Slides;